<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{pageTitle}}</div>
                    <button v-if="loginUserRoleId != 1 || loginUserRoleId != 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                </div>
                <!--Forms-->
                <form>
                    <div class="forms-container">
                        <div class="row no-margin">
                            <div class="col-12 forms-block">
                                <!-- Empolyee Name -->
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">Employee Name :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <input type="text" maxlength="190" class="form-control" v-model="empolyee_name" id="empolyee_name" placeholder="Enter Employee Name" name="empolyee_name">
                                        <div class="help is-danger">{{empolyee_name_error}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                                
                                <!-- Date of Request -->
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">Date of Request :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <date-picker placeholder="MM/DD/YYYY" id="date_of_request" name="date" v-model="date_of_request" :config="options" aria-describedby="basic-addon1"></date-picker>
                                        <div class="help is-danger">{{date_of_request_error}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                                
                                <!-- Full RA# -->
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">Full RA# :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <input type="text" maxlength="190" class="form-control" v-model="full_ra" id="full_ra" placeholder="Enter Full RA" name="full_ra">
                                        <div class="help is-danger">{{full_ra_error}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>

                                <!-- DATE RA WAS ORIGINALLY CLOSED -->
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">DATE RA WAS ORIGINALLY CLOSED :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <date-picker placeholder="MM/DD/YYYY" id="date_ra_was_originally_closed" name="date" v-model="date_ra_was_originally_closed" :config="options" aria-describedby="basic-addon1"></date-picker>
                                        <div class="help is-danger">{{date_ra_was_originally_closed_error}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>

                                <!-- Pay Type -->
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">Pay Type :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <v-select v-model="pay_type" name="pay_type"
                                            label="text"
                                            :options="pay_type_arr" :clearable=false>
                                        </v-select>
                                    </div>
                                </div>
                                
                                <!-- Location -->
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">Location :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <v-select v-model="location" name="location"
                                            label="name" placeholder="Select Location"
                                            :options="location_arr" :clearable=false>
                                        </v-select>
                                        <div class="help is-danger">{{location_error}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>

                                <!-- REASON REVERSAL IS REQUIRED -->
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">REASON REVERSAL IS REQUIRED :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <textarea type="text" class="form-control" v-model="reason" id="reason" name="reason"></textarea>
                                        <div class="help is-danger">{{reason_error}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>

                                <!-- How much time in vs billed? -->
                                <div v-if="isWarrantySelect" class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">How much time in vs Billed? :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <input type="text" class="form-control" v-model="howMuchTimeBilled" id="howMuchTimeBilled" name="howMuchTimeBilled">
                                        <div class="help is-danger">{{howMuchTimeBilledError}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>

                                <!-- What is the Tech's Efficiency MTD? -->
                                <div v-if="isWarrantySelect" class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">What is the Tech's Efficiency MTD? :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <textarea type="text" class="form-control" v-model="questions" id="questions" name="questions"></textarea>
                                        <div class="help is-danger">{{questions_error}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>

                                <div class="clearfix"></div>
                                <div class="mr-17 pb-12 float-l">
                                    <button v-if="loginUserRoleId != 1 || loginUserRoleId != 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                                    <button v-if="edit_id == 0" type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addUser('save_and_continue')"><span id="saveAndContinueAttachment">Save And Continue</span></button>
                                    <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addUser('save')"><span id="createAttachment">Save</span></button>
                                </div>

                            </div>
                        </div>
                    </div>
                </form>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPGUZZLE} from '../../../http-common.js';
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../../../components/event-bus";
    var self;
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);
    export default {
        name: 'UserAddForm',
        mixins: [commonMixins],
        data() {
            return {
                //user_role: 0,
                pageTitle: 'Add RO Reversal Request',
                edit_id: 0,
                empolyee_name: "",
                empolyee_name_error: "",
                options: {
                    format: 'MM/DD/YYYY',
                },
                date_of_request: "",
                date_of_request_error: "",
                full_ra: "",
                full_ra_error: "",
                date_ra_was_originally_closed: "",
                date_ra_was_originally_closed_error: "",
                pay_type: {text: "Customer Pay",value: "Customer Pay"},
                pay_type_arr: [
                    {
                        text: "Customer Pay",
                        value: "Customer Pay",
                    },
                    {
                        text: "Warranty",
                        value: "Warranty",
                    },
                ],
                location: "",
                location_arr: [],
                location_error: "",
                reason: "",
                reason_error: "",
                questions: "",
                questions_error: "",
                howMuchTimeBilled: "",
                howMuchTimeBilledError: "",
                isWarrantySelect: false,
                managerEmail: "",
                loginUserRoleId: 1,
            }
        },
        watch: {
            pay_type: function(pay_type) {
                self.isWarrantySelect = false;
                if(pay_type.value == 'Warranty') {
                    self.isWarrantySelect = true;
                }
            },
            location: function(location) {
                self.managerEmail = "";
                if (location != null || location.id) {
                    for(var index = 0;index<self.location_arr.length;index++) {
                        var obj = self.location_arr[index];
                        if(obj['id'] == location.id) {
                            self.managerEmail = obj['manager_email'];
                        }
                    }
                }
            },
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.menuActive("ROReversalRequest");
            self.showLoader();

            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
            }

            self.loadLocation();

            this.$nextTick(function () {
                if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                    self.edit_id = self.$route.params.id;
                    self.pageTitle = 'Edit RO Reversal Request';
                    self.getROReversalRequestById();
                    $("#addAndContinueLocationBtn").hide();
                    $("#createAttachment").html("Update");
                } else {
                    self.hideLoader();
                }
            });
        },
        methods: {
            buttonBack() {
                self.$router.push('/roreversal/list');
            },
            loadLocation: function() {
                var config = {
                    params: {
                        slug: "velocity-vehicle-group",
                        department_id: 3
                    }
                };
                self.showLoader();
                HTTPGUZZLE.get("/getdepartmentlocationswohtml", config)
                        .then(function (response) {
                            self.location_arr = response.data.locations;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            getROReversalRequestById() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {
                        id: self.edit_id
                    }
                };
                self.showLoader();
                HTTP.get("/ro-reversal-request/get", config)
                        .then(function (response) {
                            // self.first_name = response.data.content.first_name;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            checkForm: function () {
                var checked = true;
                self.empolyee_name_error = "";
                self.date_of_request_error = "";
                self.full_ra_error = "";
                self.date_ra_was_originally_closed_error = "";
                self.location_error = "";
                self.reason_error = "";
                self.questions_error = "";
                self.howMuchTimeBilledError = "";

                if (!self.empolyee_name) {
                    self.empolyee_name_error = "Please enter employee name";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.date_of_request) {
                    self.date_of_request_error = "Select Date of Request";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.full_ra) {
                    self.full_ra_error = "Please enter Full RA";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.date_ra_was_originally_closed) {
                    self.date_ra_was_originally_closed_error = "Select Date RA was originally Closed Date";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.location == null || !self.location.id) {
                    self.location_error = "select Location";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.reason) {
                    self.reason_error = "Please enter reason";
                    if (checked) {
                        checked = false;
                    }
                }
                if(self.isWarrantySelect) {
                    if (!self.questions) {
                        self.questions_error = "Please enter question";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if(self.isWarrantySelect) {
                    if (!self.howMuchTimeBilled) {
                        self.howMuchTimeBilledError = "Please enter Billed time";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                return checked;
            },
            addUser(flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                        };
                        var fields = {
                            manager_email: self.managerEmail,
                            empolyee_name: self.empolyee_name,
                            date_of_request: self.date_of_request,
                            full_ra: self.full_ra,
                            date_ra_was_originally_closed: self.date_ra_was_originally_closed,
                            pay_type: self.pay_type.value,
                            location: self.location.id,
                            reason: self.reason,
                            questions: self.questions,
                            howMuchTimeBilled: self.howMuchTimeBilled,
                            id: self.edit_id,
                        };
                        self.showLoader();
                        HTTP.post("/ro-reversal-request/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    if (flag == 'save') {
                                        if(self.loginUserRoleId == 1 || self.loginUserRoleId == 2) {
                                            self.buttonBack();
                                        } else {
                                            self.empolyee_name = '';
                                            self.date_of_request = '';
                                            self.full_ra = '';
                                            self.date_ra_was_originally_closed = '';
                                            self.pay_type = {text: "Customer Pay", value: "Customer Pay"};
                                            self.location = '';
                                            self.reason = '';
                                            self.isWarrantySelect = false;
                                            self.questions = '';
                                            self.howMuchTimeBilled = '';
                                            self.manager_email = '';
                                        }
                                    } else {                                        
                                        self.empolyee_name = '';
                                        self.date_of_request = '';
                                        self.full_ra = '';
                                        self.date_ra_was_originally_closed = '';
                                        self.pay_type = {text: "Customer Pay", value: "Customer Pay"};
                                        self.location = '';
                                        self.reason = '';
                                        self.isWarrantySelect = false;
                                        self.questions = '';
                                        self.howMuchTimeBilled = '';
                                        self.manager_email = '';
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/Forms/ROReversalRequest/AddUpdateROReversalRequest.vue